export default __webpack_public_path__ + "static/media/back_arrow_white.d0db3f44.svg";